if ($(".el-event-agenda-content").length > 0) {
  console.log("scrollbar.js");
  $(document).ready(function () {
    $(".el-event-agenda-content").each(function () {
      new SimpleBar(this);
    });
  });
}
